import { NgxWebstorageConfiguration } from 'ngx-webstorage/lib/config';

export class WebStorageConfig implements NgxWebstorageConfiguration {
    public prefix: string;
    public separator: string;
}
